export const ApiResources = {
  Agent: 'agent.Agents',
  Technician: 'service.Technicians',
  TechnicianLocation: 'service.TechnicianLocation',
  AgentCommissionRule: 'agent.CommissionRules',
  AgentLevel: 'agent.AgentLevel',
  AgentGroup: 'agent.AgentGroup',
  AgentCommissions: 'agent.AgentCommissions',
  Contract:'payment.Contracts',
  CustomerGroup: 'customer.CustomerGroups',
  CustomerMembership: 'customer.CustomerMemberships',
  Customer: 'customer.Customers',
  RewardTransaction: 'customer.RewardTransaction',
  CustomerReward: 'customer.CustomerReward',
  Reward: 'customer.Reward',
  PotentialAgent: 'customer.PotentialAgent',
  HotLead: 'customer.HotLeads',
  AgingReport: 'payment.AgingReport',
  Membership: 'customer.Memberships',
  CustomerProductBalance: 'customer.ProductBalance',
  Bank: 'network.BankMaster',
  Company: 'network.CompanyProfiles',
  Currency: 'network.Currency',
  ItemTaxGroup: 'network.ItemTaxGroups',
  PurchaseOrder: 'network.PurchaseOrders',
  TaxCode: 'network.TaxCodes',
  Setting: 'network.Settings',
  SaleOrder: 'network.SaleOrders',
  DeliveryOrder: 'network.DeliveryOrders',
  RequestQuotation: 'network.RequestQuotations',
  Notification: 'admin.Notifications',
  Appointment: 'service.Appointments',
  TaxGroup: 'network.TaxGroups',
  UOM: 'network.Uom',
  Transaction: 'payment.Transactions',
  Invoice: 'payment.Invoices',
  NotificationMessage: 'network.NotificationMessage',
  CreditNote: 'payment.CreditNotes',
  InvoiceCancelled: 'payment.InvoiceCancelled',
  PaymentTerm: 'payment.PaymentTerms',
  CostSetup: 'product.CostSetup',
  CostTypeSetup: 'product.CostTypeSetup',
  DimensionSetup: 'product.DimensionSetup',
  Location: 'product.Location',
  LocationSetup: 'product.LocationSetup',
  LocationUnit: 'product.LocationUnit',
  Product: 'product.Product',
  MovingJournal: 'product.MovingJournal',
  ProductCategory: 'product.ProductCategory',
  ProductType: 'product.ProductType',
  Warranty: 'product.Warranty',
  WarrantyType: 'product.WarrantyType',
  LocationSorting: 'product.LocSortingHeader',
  Brand: 'product.Brand',
  PurchaseSetup: 'network.PurchaseSetups',
  ServiceMovingJournal: 'service.ServiceMovingJournals',
  Timeslot: 'service.Timeslots',
  Holiday: 'service.Holidays',
  ProductSerialNumber: 'product.ProductSerialNumber',
};
